import { AdminApi } from 'stylemix-vue-admin'

export default class BillingInfoApi extends AdminApi {
  constructor(parameters) {
    super('billing-info', parameters)
  }

  async makeDefault(id) {
    return this.submit('post', `/${this.endpoint}/${id}/default`)
  }
}
